export default __webpack_public_path__ + "assets/images/13e4d36d4db9d2378df3fab82af19e8f-commitment_to_the_climate.svg";